window._ = require('lodash');
window.Popper = require('popper.js').default;
import store from './store';

window.axios = require('axios');

window.axios.interceptors.request.use(config => {
    config.params = {XDEBUG_SESSION_START: 'PHPSTORM'}
    config.headers.Authorization = "bearer " + localStorage.getItem('token')
    //document.body.classList.add('loading-indicator');
    // NProgress.start();
    return config;
});

window.axios.interceptors.response.use(function (response) {
    // Do something with response data
    window.scrollTo(0,0)
    return response;
}, function (error) {
    window.scrollTo(0,0)

    // Do something with response error
    if (error.response.status == 401 && store.state.isLoggedIn) { // todo make this better
        return window.location = '#/logout';
    }

    return Promise.reject(error);
});


//window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// window.axios.defaults.params['XDEBUG_SESSION_START'] = 'PHPSTORM';
window.axios.defaults.baseURL = 'https://bayhorse.myadminweb.com/api/v1';